
import React, { useState, useEffect, memo, useMemo, useRef } from 'react';
import ValuesStore from '../../store/values-store';
import { useNavigate } from 'react-router-dom';
import utils from '../../dependencies/custom/react-utilities';
import { Space, Button, Card, Tag, message, Tooltip, Popover, Form, Input } from 'antd';


import useTable from '../../hooks/table';
import useAdd from '../../hooks/add';
import useEdit from '../../hooks/edit';
import useDelete from '../../hooks/delete';
import Settings from '../../dependencies/custom/settings';
import useDynamicForm from '../../hooks/dynamic_form';
import CustomFunctions from '../../dependencies/custom/custom-functions';
import AppContainer from '../../components/container';

const CourseAssignment = (props) => {
    const valuesStore = ValuesStore();
    const extraFiltersAddMeta = 'extraFiltersAddMeta';
    // const coursesForTransferFilter = 'coursesForTransferFilter';    
    const add = useAdd('tables_metadata', 'table_name');
    const edit = useEdit('tables_metadata', 'table_name');
    const extraFiltersAdd = useAdd(extraFiltersAddMeta, 'table_name');
    // const coursesForTransferAdd = useAdd(coursesForTransferFilter, 'table_name');
    const del = useDelete();
    const { filters, filterTypes } = utils.generateTableFilters();
    const [dateRange, setDateRange] = useState([]);
    const navigate = useNavigate();
    // const keyOverrides = { categoryAlias: 'category' };
    const [btnPermissions, setBtnPermissions] = useState({});
    const [sheetInfo, setSheetInfo] = useState({});
    const formData = [
        { name: 'label', isRequired: true, errorMsg: 'Field is required', placeholder: 'Enter column label', inputType: 'text' },
        { name: 'marks', isRequired: true, errorMsg: 'Field is required', placeholder: 'Enter marks', inputType: 'number' }
    ];
    const dynamicForm = useDynamicForm('myForm', formData, { text: <><i className='fas fa-paper-plane me-1' />Submit</>, type: 'primary' });
    const [recalledColumnInfo, setRecalledColumnInfo] = useState({});
    const [hasSetPersistedFilters, setHasSetPersistedFilters] = useState(false);
    const tableFilterName = 'CACHED_TABLE_HOOK_FILTERS';

    //and key value that points to the table names from zustand store.    
    const table = useTable(
        {
            pagination: {
                current: 1,
                pageSize: 10,
                position: ['bottomRight', 'topRight'],
                hideOnSinglePage: true
            },
            filters: { ...filters },
            filterTypes: { ...filterTypes }
        },
        undefined,
        'post',
        'result',
        'totalCount',
        'id',
        { /*alias: 'LIKE', acadyr: 'LIKE', semester: 'IN', end_date: 'IN', is_active: 'IN' */ },
        { table: 'course_lecturer', fields: ['*'] }, true);

  

    function actionExtraButtons(record) {
        const btns = <div>
            {/* {btnPermissions?.show_transfer_button &&
                <Popover placement="topLeft" title={'Transfer course'} content={courseTransferJSX(record)} trigger="click">
                    <Button><i className='fas fa-paper-plane me-2' /> Transfer </Button>
                </Popover>
            } */}
            {btnPermissions?.show_approve_button && <Button onClick={e => changeSheetStatus(record, 'approve', 'single')}><i className='far fa-check-circle me-2' /> Approve</Button>}
            {btnPermissions?.show_release_sheet_button && <Button onClick={e => changeSheetStatus(record, 'release', 'single')}><i className='fas fa-unlock me-2' /> Release</Button>}
            {btnPermissions?.show_publish_button && <Button onClick={e => changeSheetStatus(record, 'publish', 'single')}><i className='fas fa-check-double  me-2' /> Publish</Button>}
            {btnPermissions?.show_unpublish_button && <Button onClick={e => changeSheetStatus(record, 'unpublish', 'single')}><i className='far fa-times-circle me-2' /> Unpublish </Button>}
        </div>;
        return btns;
    }

    // function courseTransferJSX(record) {
    //     return <div className=''>
    //         {coursesForTransferAdd.form}
    //         <Button onClick={e => transferCourse(record)} className='btn-info border-0'><i className='fas fa-paper-plane me-1' />Transfer</Button>
    //     </div>;
    // }

    // async function transferCourse(record) {
    //     const data = { mounted_course_id: record?.mounted_course_id, ...coursesForTransferAdd.record };
    //     const res = await utils.requestWithReauth('post', `${Settings.backend}/transfer_course`, null, data);
    //     if (res.status == 'Ok') {
    //         utils.showNotification(undefined, 'Operation successful', 'text-success');
    //     } else {
    //         utils.showNotification(undefined, res.msg);
    //     }

    // }

    function changeSheetStatus(record, status, type, table) {
        CustomFunctions.courseMgtChangeSheetStatus(record, status, type, table);
    }


    function delCallback(status) {
        if (status) {
            dynamicForm.setShowModal(false);
        }
    }


    function recallColumn(label, marks, record) {
        setRecalledColumnInfo(record);
        const a = CustomFunctions.courseMgtSetExamsField(valuesStore, dynamicForm);
        //prepare the input fields
        dynamicForm.setFormChildren([a,
            <Space
                key={'2'}
                style={{
                    display: 'flex',
                    marginBottom: 8,
                }}
                align="baseline"
            >
                <Form.Item
                    name="label"
                    label="Label"
                    rules={[
                        {
                            required: true,
                        }
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="marks"
                    label="Marks"
                    rules={[
                        {
                            required: true
                        }
                    ]}
                >
                    <Input type='number' />
                </Form.Item>
            </Space>
        ]);
        //set the values to the prepared input fields. values get assigned through the name prop of the Form.Item component
        dynamicForm.form.setFieldsValue({
            label: label,
            marks: marks
        });
    }

    // function coursesForTransfer() {
    //     setTimeout(e => {
    //         valuesStore.setValue(coursesForTransferFilter, [
    //             {
    //                 id: '', table_name: 'courses_for_transfer',
    //                 column_name: 'dept', col_real_name: 'Department', type: 'sqlSelect',
    //                 options: '{"sql":"SELECT name,alias FROM organizational_type WHERE type in (4,5)","key":"alias","value":"name"}',
    //                 extra_options: '',
    //                 backend_visible: 1, front_visible: 0,
    //                 editable: 1, validator: '', icon: '', rank: 1
    //             }]);
    //         coursesForTransferAdd.setTblName('courses_for_transfer');
    //     }, 1000);
    // }

    const columns = CustomFunctions.courseMgtColumns(btnPermissions, dynamicForm, recallColumn, del, delCallback, setSheetInfo, table, tableFilterName, setHasSetPersistedFilters, navigate, edit, valuesStore, actionExtraButtons);

    useMemo(() => {
        if (!dynamicForm.formChildren) {
            // setExamsField();
            CustomFunctions.courseMgtSetExamsField(valuesStore, dynamicForm);
        }
        //the permissions are arranged from max to min. Max perms have the highest priority
        const permList = [
            'get_assigned_courses_root',
            'get_assigned_courses',
            'get_assigned_courses_lecturer'];
        CustomFunctions.courseMgtSetTableDataURL(permList, valuesStore, table);


        // coursesForTransfer();
        CustomFunctions.courseMgtSetPersistedFilters(tableFilterName, columns, table, hasSetPersistedFilters, setHasSetPersistedFilters);
        table.setColumns(columns);
        table.setColFilters(CustomFunctions.courseMgtColFilters, columns, `${Settings.backend}/get_col_filters`);
        table.setAllowSelection(true);
        if (table.dataURL) {
            table.fetchData();
        }
        // console.log(table.tableParams,columns);
        console.log('looping');
        // applyFilter();
        CustomFunctions.courseMgtShowBtnUsingPermissions(btnPermissions, setBtnPermissions, valuesStore, table);

        dynamicForm.setFormSubmit({
            async onFormSubmit(values) {
                CustomFunctions.courseMgtSubmitScheme(sheetInfo, recalledColumnInfo, values, dynamicForm, valuesStore);
            }
        });
    }, [JSON.stringify(table.tableParams), edit.saveCompleted, sheetInfo, recalledColumnInfo, add.saveCompleted, del.saveCompleted, btnPermissions,/*,coursesForTransferAdd.form*/]);

    async function addOnOk() {
        let res = await utils.requestWithReauth('post', `${Settings.backend}/save_assign_course`, null, add.record);
        if (res.status === 'Ok') {
            add.reset();
            utils.showNotification(undefined, 'Operation successful', 'text-success');
        } else {
            utils.showNotification(undefined, res.msg);
        }
    }
    async function editOnOk() {
        let res = await utils.requestWithReauth('post', `${Settings.backend}/edit_assigned_course`, null, edit.record);
        if (res.status === 'Ok') {
            edit.reset();
            utils.showNotification(undefined, 'Operation successful', 'text-success');
        } else {
            utils.showNotification(undefined, res.msg);
        }
    }

    return (
        <>
            <AppContainer
                extra={
                    <>
                        {btnPermissions?.show_assign_course_button && <Button className='btn-success border-0' onClick={e => CustomFunctions.courseMgtAssignCourse(add, 'course_lecturer')}><i className='fas fa-user-plus me-2' /> Assign Course</Button>}
                        {/* <Button className='btn-primary' onClick={e => applyFilter()}><i className='fas fa-filter me-2' />Filter</Button> */}
                        <Button className='btn-primary' onClick={e => CustomFunctions.resetTable(tableFilterName, navigate)}><i className='fas fa-filter me-2' /> Clear All Filters</Button>
                        {btnPermissions?.show_approve_button && <Button className='btn-primary' onClick={e => changeSheetStatus(null, 'approve', 'multiple', table)}><i className='far fa-check-circle me-2' /> Approve All</Button>}
                        {btnPermissions?.show_release_sheet_button && <Button className='btn-primary' onClick={e => changeSheetStatus(null, 'release', 'multiple', table)}><i className='fas fa-unlock me-2' /> Release All</Button>}
                        {btnPermissions?.show_publish_button && <Button className='btn-primary' onClick={e => changeSheetStatus(null, 'publish', 'multiple', table)}><i className='fas fa-check-double  me-2' /> Publish All</Button>}
                        {btnPermissions?.show_unpublish_button && <Button className='btn-primary' onClick={e => changeSheetStatus(null, 'unpublish', 'multiple', table)}><i className='far fa-times-circle me-2' /> Unpublish All </Button>}
                    </>
                }
                title={'Course Mgt.'}
                children={
                    <div className='row'>
                        <div className='col-md-12 mb-2'>
                            <div className='mt-2'>
                                <div className='row row-cols-2'>
                                    {extraFiltersAdd?.form?.map((v, i) => <div key={i}>{v}</div>)}
                                </div>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='table-responsive h-scrolling-wrapper'>
                                {table.tableWithHeaderFooter()}
                            </div>
                        </div>
                    </div>
                }
                table={table}
            />

            {add.addModal('Assign Course', addOnOk, undefined, undefined, 800)}
            {edit.editModal('Edit Assigned Course', editOnOk, undefined, undefined, 800)}
            {dynamicForm.formModal(null, null)}
        </>
    );
}

export default memo(CourseAssignment);